module.exports = __webpack_public_path__ + "img/company.ed3c60ed.png";